import React from 'react';
import routes from '../../../routing/routes';
import footerResources from '../footerResources';
import Image from '../../Image/Image';
import FooterMenuItem from '../FooterMenuItem';
import { HEALTHY_CONTRIBUTIONS_LEGAL_NAME } from '../../../constants/companyNames';
import CustomLink from '../../controls/CustomLink';

function FooterPublic() {
    const solutionsSubMenuId = 'solutionsSubMenu';
    const contactSubMenuId = 'contactSubMenu';
    const legalSubMenuId = 'legalSubMenu';
    return (
        <footer>
            <div className="footer">
                <div className="footer__content">
                    <div className="footer__menu-container">
                        <ul className="footer__menu-list" role="presentation">
                            <FooterMenuItem id="solutionsMenu" description={footerResources.sectionNameSolutions} active>
                                <ul id={solutionsSubMenuId} className="footer-menu-item__submenu-list">
                                    <li>
                                        <CustomLink
                                            className="footer-menu-item__submenu-link"
                                            linkPath={routes.forFacilities.path}
                                        >
                                            {footerResources.linkNameForFacilities}
                                        </CustomLink>
                                    </li>
                                    <li>
                                        <CustomLink
                                            className="footer-menu-item__submenu-link"
                                            linkPath={routes.forEmployers.path}
                                        >
                                            {footerResources.linkNameForEmployers}
                                        </CustomLink>
                                    </li>
                                    <li>
                                        <CustomLink
                                            className="footer-menu-item__submenu-link"
                                            linkPath={routes.forMembers.path}
                                        >
                                            {footerResources.linkNameForMembers}
                                        </CustomLink>
                                    </li>
                                    <li>
                                        <CustomLink
                                            className="footer-menu-item__submenu-link"
                                            linkPath={routes.forInsurers.path}
                                        >
                                            {footerResources.linkNameForInsurers}
                                        </CustomLink>
                                    </li>
                                </ul>
                            </FooterMenuItem>
                            <FooterMenuItem id="contactMenu" description={footerResources.sectionNameContact}>
                                <ul id={contactSubMenuId} className="footer-menu-item__submenu-list">
                                    <li>
                                        <CustomLink
                                            className="footer-menu-item__submenu-link"
                                            linkPath={routes.aboutUs.path}
                                        >
                                            {footerResources.linkNameAbout}
                                        </CustomLink>
                                    </li>
                                </ul>
                            </FooterMenuItem>
                            <FooterMenuItem id="legalMenu" description={footerResources.sectionNameLegal}>
                                <ul id={legalSubMenuId} className="footer-menu-item__submenu-list">
                                    <li>
                                        <CustomLink
                                            className="footer-menu-item__submenu-link"
                                            linkPath={routes.privacynotice.path}
                                        >
                                            {footerResources.linkNamePrivacyNotice}
                                        </CustomLink>
                                    </li>
                                    <li>
                                        <CustomLink
                                            className="footer-menu-item__submenu-link"
                                            linkPath={routes.consumerhealthprivacynotice.path}
                                        >
                                            {footerResources.linkNameConsumerHealthPrivacyNotice}
                                        </CustomLink>
                                    </li>
                                    <li>
                                        <CustomLink
                                            className="footer-menu-item__submenu-link"
                                            linkPath={routes.termsofuse.path}
                                        >
                                            {footerResources.linkNameTermsOfUse}
                                        </CustomLink>
                                    </li>
                                    <li>
                                        <CustomLink
                                            className="footer-menu-item__submenu-link"
                                            linkPath={routes.accessibilityAndMaintenance.path}
                                        >
                                            {footerResources.linkNameAccessibilityAndMaintenance}
                                        </CustomLink>
                                    </li>
                                </ul>
                            </FooterMenuItem>
                        </ul>
                    </div >
                    <div className="footer__container">
                        <div className="footer__privacy-container">
                            <div className="footer__logo-container">
                                <a href={routes.home.path} className="footer__logo-image-wrapper">
                                    <Image image="logoWhite" alt="Healthy Contributions" />
                                </a>
                                <div className="footer__copyright-container footer__copyright-text">
                                    Copyright © {new Date().getFullYear()} {HEALTHY_CONTRIBUTIONS_LEGAL_NAME}. All rights reserved.
                                </div>
                            </div>
                            <div className="footer__cookie-container" dangerouslySetInnerHTML={{ __html: '<a id="ot-sdk-link" className="ot-sdk-show-settings" href="#" alt="Cookie Settings" onclick="window.OneTrust.ToggleInfoDisplay()">Cookie Settings</a>' }} />
                        </div>
                    </div>
                </div >
            </div >
        </footer>
    );
}

export default FooterPublic;
